const ArnieTapleyDecoration = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="275"
            height="218"
            fill="none"
            viewBox="0 0 275 218"
        >
            <path
                fill="#FF8F00"
                d="M194.541 148.941c2.805 4.661 5.074 7.456 8.846 11.014.457.431.525 1.136.15 1.639l-7.275 9.788c-.514.692-1.563.651-1.999-.091-4.137-7.036-4.874-12.37-1.937-22.104.305-1.013 1.669-1.152 2.215-.246z"
            ></path>
            <circle
                r="40.485"
                fill="#FF8F00"
                transform="matrix(-1 0 0 1 234.229 176.911)"
            ></circle>
            <path
                stroke="#000"
                strokeWidth="2.387"
                d="M208.225 159.642l.372-17.309c.171-7.973 6.61-14.385 14.583-14.523l5.424-.094c5.317-.093 9.678 4.193 9.678 9.511v0"
            ></path>
            <rect
                width="20.075"
                height="28.786"
                fill="#000"
                rx="4.713"
                transform="scale(1 -1) rotate(-1.786 -5901.403 -6444.83)"
            ></rect>
            <circle
                r="4.498"
                fill="#000"
                transform="scale(-1 1) rotate(7.862 -1329.378 -1782.869)"
            ></circle>
            <path
                stroke="#000"
                strokeLinecap="round"
                strokeWidth="3.272"
                d="M1.636 -1.636L8.179 -1.636"
                transform="scale(-1 1) rotate(-82.138 -27.614 234.445)"
            ></path>
            <path
                stroke="#000"
                strokeLinecap="round"
                strokeWidth="5.309"
                d="M247.984 159.012c-1.773-6.159-3.37-9.618-7.388-15.803M237.638 164.11c-1.773-6.158-3.371-9.618-7.388-15.803"
            ></path>
            <path
                stroke="#FF8F00"
                strokeLinecap="round"
                strokeWidth="7.215"
                d="M195.553 206.297c12.165 7.634 18.351 7.665 28.305.479"
            ></path>
            <path
                fill="#FF8F00"
                d="M223.558 126.886c.402 5.425 1.167 8.943 2.929 13.82a1.24 1.24 0 01-.606 1.531l-10.908 5.454c-.771.385-1.688-.124-1.743-.983-.518-8.146 1.229-13.238 8.24-20.601.73-.767 2.01-.276 2.088.779z"
            ></path>
            <path
                fill="#EF6C00"
                d="M162.028 91.986c0-35.353-28.659-64.012-64.011-64.012-35.353 0-64.012 28.66-64.012 64.012v102.046c0 12.809 10.384 23.193 23.193 23.193h81.637c12.809 0 23.193-10.384 23.193-23.193V91.986z"
            ></path>
            <path
                fill="#EF6C00"
                d="M107.516 12.628c-2.802 6.83-4.008 11.564-4.827 18.554a1.682 1.682 0 01-1.664 1.49l-16.552.006c-1.169 0-1.974-1.174-1.52-2.25 4.313-10.204 9.523-15.327 22.501-20.013 1.351-.488 2.607.884 2.062 2.213zM78.981 19.944c-1.537 7.22-1.877 12.095-1.434 19.118a1.682 1.682 0 01-1.371 1.765l-16.284 2.962c-1.15.21-2.153-.802-1.897-1.943 2.419-10.81 6.63-16.78 18.562-23.71 1.242-.722 2.723.403 2.424 1.808z"
            ></path>
            <path
                stroke="#EF6C00"
                strokeLinecap="round"
                strokeWidth="16.413"
                d="M9.196 178.376c12.302 20.136 21.379 24.711 41.28 21.431"
            ></path>
            <circle
                r="7.675"
                fill="#000"
                transform="matrix(-1 0 0 1 128.269 78.383)"
            ></circle>
            <path
                stroke="#000"
                strokeLinecap="round"
                strokeWidth="5.582"
                d="M2.791 -2.791L13.954 -2.791"
                transform="matrix(0 -1 -1 0 125.478 95.128)"
            ></path>
            <path
                stroke="#352005"
                strokeLinecap="round"
                strokeWidth="2.775"
                d="M134.563 57.612c0 2.02-.547 4.652.713 6.271.315.406 2.283 3.573.453 2.707-2.712-1.285-5.597-2.616-7.745-4.765-1.074-1.073-2.025-2.255-3.047-3.338-.879-.93-.503.476-.81 1.167-.478 1.075.774 4.375-.794 4.375-1.868 0-4.007-2.29-5.04-3.63-.614-.795-1.311-1.707-1.783-2.592-.169-.319-.615-1.253-.615-.892 0 1.033-.634 2.092-1.037 3.014-.427.976-.932 1.966-1.362 2.934-.301.677.45 2.204-.291 2.204-1.424 0-5.176-2.766-5.769-4.1-.15-.338-.598-1.92-.875-2.058-.025-.012-1.047 1.793-1.167 1.977-.481.735-1.244 1.522-1.442 2.414-.059.266.063 2.13-.179 2.026-1.661-.712-3.72-.88-5.088-2.172-1.205-1.138-2.333-2.217-2.333-3.905 0-.184-.133.376-.292.47-.364.214-.86.521-1.167.81-.618.583-1.016 1.288-1.394 2.042-.348.697-3.564 2.571-3.564 1.313v-4.522"
            ></path>
            <path
                stroke="#000"
                strokeWidth="4.42"
                d="M32.397 86.588l.875-21.046C34.726 30.588 63.485 3 98.469 3v0c36.038 0 65.253 29.215 65.253 65.254v28.792"
            ></path>
            <path
                fill="#000"
                d="M176.431 79.83a4.42 4.42 0 00-4.419-4.42h-10.608v37.127h10.608a4.42 4.42 0 004.419-4.42V79.83zM18.96 109.131a4.42 4.42 0 004.28 4.555l10.602.331L35 76.909l-10.603-.33a4.42 4.42 0 00-4.555 4.28l-.882 28.272z"
            ></path>
        </svg>
    );
};

export default ArnieTapleyDecoration;
